import _ from "lodash";

import { ICompanyTableControls } from "@store/filters/filter.types";

const numberOfActiveFilters = (
  state: ICompanyTableControls["filters"],
  initialState: ICompanyTableControls["filters"],
) => {
  // Create a copy of the state object, excluding the page, query, pageSize, and sort properties
  const stateCopy = _.omit(state, ["query", "search", "companyTypes", "companyEmployeeSizes"]);

  // Check if maxEmployees exists and is null, set it to Infinity
  if ("maxEmployees" in stateCopy && stateCopy.maxEmployees === null) {
    stateCopy.maxEmployees = Infinity;
  }

  // Filter out empty arrays, empty objects, and falsy values
  const filteredStateCopy = Object.fromEntries(
    Object.entries(stateCopy).filter(([, value]) => {
      return !(
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === "object" && value !== null && Object.keys(value).length === 0) ||
        !value
      );
    }),
  );

  // Create a copy of the initialState object, excluding the same properties
  const initialStateCopy = _.omit(initialState, ["query", "search", "companyTypes", "companyEmployeeSizes"]);

  // Filter the initialState the same way
  const filteredInitialStateCopy = Object.fromEntries(
    Object.entries(initialStateCopy).filter(([, value]) => {
      return !(
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === "object" && value !== null && Object.keys(value).length === 0) ||
        !value
      );
    }),
  );

  // Count filters that are different from initial state
  let diffCount = 0;

  // Check for keys in current state that differ from initial state
  for (const [key, value] of Object.entries(filteredStateCopy)) {
    if (!_.isEqual(value, filteredInitialStateCopy[key])) {
      diffCount++;
    }
  }

  // Check for keys in initial state that aren't in current state
  for (const key of Object.keys(filteredInitialStateCopy)) {
    if (!(key in filteredStateCopy)) {
      diffCount++;
    }
  }

  return diffCount;
};

export default numberOfActiveFilters;
